import { SESSION_RECORDING_EVENTS, sendSessionRecordingEvent } from "utils/session-recording"

export default function trackSignupRecordingEvent(node) {
  if (node.classList.contains("js-sign-up-no-free")) {
    sendSessionRecordingEvent(SESSION_RECORDING_EVENTS.signupNoFreeClick)
  }
}
